import { render, staticRenderFns } from "./ServeOrderEdit.vue?vue&type=template&id=2ec542b4&"
import script from "./ServeOrderEdit.vue?vue&type=script&lang=js&"
export * from "./ServeOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServeOrderEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports